import React, { useRef, useState } from 'react'
import Slides from '../slides/Slides'
import Footer from '../footer/Footer'
import showLoading from '../../js/showLoading';
import axios from 'axios';
import Swal from 'sweetalert2';
import { toast, ToastContainer, Zoom } from 'react-toastify';

const ConsultasReclamos = ({M}) => {
   const [consultaReclamo, setConsultaReclamo] = useState({
      nombre:null,
      apellido:null,
      dni:null,
      cuit_cuil:null,
      email:null,
      telefono:null,
      domicilio:null,
      tipo:null,
      tipo_consulta:null,
      tema_consulta:null,
      mensaje:null,
   });
   
   const iNombreRef        = useRef(null);
   const iApellidoRef      = useRef(null);
   const iDniRef           = useRef(null);
   const iCuitCuilRef      = useRef(null);
   const iEmailRef         = useRef(null);
   const iTelefonoRef      = useRef(null);
   const iDomiciolioRef    = useRef(null);
   const sTipoRef          = useRef(null);
   const sTipoConsultaRef  = useRef(null);
   const sTemaConsultaRef  = useRef(null);
   const tMensajeRef       = useRef(null);
   
   const handleSubmit = (e) => {
         e.preventDefault();
         if (consultaReclamo.nombre === null || consultaReclamo.nombre === "") {
            toast.error("Ingrese el Nombre", { transition: Zoom });
            iNombreRef.current.focus();
            return;
         }
         if (consultaReclamo.apellido === null || consultaReclamo.apellido === "") {
            toast.error("Ingrese el Apellido", { transition: Zoom });
            iApellidoRef.current.focus();
            return;
         }
         if (consultaReclamo.dni === null || consultaReclamo.dni === "") {
            toast.error("Ingrese el D.N.I", { transition: Zoom });
            iDniRef.current.focus();
            return;
         }
         if (consultaReclamo.cuit_cuil === null || consultaReclamo.cuit_cuil === "") {
            toast.error("Ingrese el CUIT/CUIL", { transition: Zoom });
            iCuitCuilRef.current.focus();
            return;
         }
         if (consultaReclamo.email === null || consultaReclamo.email === "") {
            toast.error("Ingrese el E-mail", { transition: Zoom });
            iEmailRef.current.focus();
            return;
         }
         if (consultaReclamo.telefono === null || consultaReclamo.telefono === "") {
            toast.error("Ingrese el Teléfono", { transition: Zoom });
            iTelefonoRef.current.focus();
            return;
         }
         if (consultaReclamo.domicilio === null || consultaReclamo.domicilio === "") {
            toast.error("Ingrese el Domicilio", { transition: Zoom });
            iDomiciolioRef.current.focus();
            return;
         }
         if (consultaReclamo.tipo === null || consultaReclamo.tipo === "") {
            toast.error("Ingrese el Tipo", { transition: Zoom });
            sTipoRef.current.focus();
            return;
         }
         if (consultaReclamo.tipo_consulta === null || consultaReclamo.tipo_consulta === "") {
            toast.error("Ingrese el Tipo de Consulta", { transition: Zoom });
            sTipoConsultaRef.current.focus();
            return;
         }
         if (consultaReclamo.tema_consulta === null || consultaReclamo.tema_consulta === "") {
            toast.error("Ingrese el Tema de Consulta", { transition: Zoom });
            sTemaConsultaRef.current.focus();
            return;
         }
         if (consultaReclamo.mensaje === null || consultaReclamo.mensaje === "") {
            toast.error("Ingrese el Mensaje", { transition: Zoom });
            tMensajeRef.current.focus();
            return;
         }

         showLoading();
         axios
         .post(`${process.env.REACT_APP_API_URL}/web/consultasReclamos`,consultaReclamo)
         .then((payload) => {
            Swal.fire({
               icon: payload.data.icon,
               title: payload.data.title,
               text: payload.data.message,
               showConfirmButton: true,
               confirmButtonText: "Ok",
            }).then((response) => {});
         }).catch((error) => {
            Swal.fire({
               icon: "error",
               title: "Error!",
               text: error.response.data.error,
               showConfirmButton: true,
               confirmButtonText: "Ok",
            });
         });
   }
   return (
      <>
         <Slides M={M} tipoSlides={"consultasReclamos"}/>
         {/* <div className="container">
            <div className="section">
               <div className="section center">
                  <h5><strong>Consultás y reclamos</strong></h5>
                  <p><strong>Completá el siguiente formulario de consultas/reclamos y un representante nuestro se comunicará a la brevedad</strong></p>
               </div>
               <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                     <div className="card">
                        <div className="card-content">
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="text" name="nombre"  id="nombre" ref={iNombreRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       nombre:e.target.value
                                    })}
                                    className="validate" data-length="15" />
                                    <label for="nombre">Nombre</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="text" name="apellido" id="apellido" ref={iApellidoRef} 
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       apellido:e.target.value
                                    })}
                                    className="validate" data-length="15" />
                                    <label for="apellido">Apellido</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="number" name="dni" id="dni" ref={iDniRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       dni:e.target.value
                                    })}
                                    className="validate" data-length="10" />
                                    <label for="dni">D.N.I</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="number" name="cuit_cuil" id="cuit_cuil" ref={iCuitCuilRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       cuit_cuil:e.target.value
                                    })}
                                    className="validate" data-length="13" />
                                 <label for="cuit_cuil">CUIT/CUIL</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="email" name="email" id="email" ref={iEmailRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       email:e.target.value
                                    })}
                                 className="validate" data-length="35" />
                                 <label for="email">E-mail</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="tel" name="telefono" id="telefono" ref={iTelefonoRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       telefono:e.target.value
                                    })}
                                    className="validate" data-length="20"/>
                                 <label for="telefono">Teléfono</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="text" name="domicilio" id="domicilio" ref={iDomiciolioRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       domicilio:e.target.value
                                    })}
                                    className="validate" data-length="60" />
                                 <label for="domicilio">Domicilio</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <select name="tipo" id="tipo" ref={sTipoRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       tipo:e.target.value,
                                    })} className="browser-default"
                                 >
                                    <option value="" disabled selected>Tipo</option>
                                    <option value="Trabajador">Trabajador</option>
                                    <option value="Empleador">Empleador</option>
                                 </select>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <select name="tipo_consulta" id="tipo_consulta"  ref={sTipoConsultaRef}
                                       onChange={(e) => setConsultaReclamo({
                                          ...consultaReclamo, 
                                          tipo_consulta:e.target.value,
                                       })}   className="browser-default"
                                 >
                                    <option value="" disabled selected>Tipo de consulta</option>
                                    <option value="Consulta">Consulta</option>
                                    <option value="Reclamos">Reclamos</option>
                                 </select>
                              </div>
                              <div className="input-field col s12 m6">
                                 <select name="tema_consulta" id="tema_consulta" ref={sTemaConsultaRef}
                                       onChange={(e) => setConsultaReclamo({
                                          ...consultaReclamo, 
                                          tema_consulta:e.target.value,
                                       })} className="browser-default"
                                 >
                                    <option value="" disabled selected>Tema de consulta</option>
                                    <option value="1">Comisión médica</option>
                                    <option value="2">Prestaciones en especie</option>
                                    <option value="3">Prestaciones en dinerarias</option>
                                    <option value="4">Prevención</option>
                                    <option value="5">Exámenes Médicos</option>
                                    <option value="6">Afiliaciones y Contratos</option>
                                    <option value="7">Otros</option>
                                 </select>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col s12 m12">
                                 <div className="input-field">
                                    <textarea name="mensaje" cols="40" rows="10" id="mensaje" ref={tMensajeRef}
                                       onChange={(e) => setConsultaReclamo({
                                          ...consultaReclamo, 
                                          mensaje:e.target.value,
                                       })} type="textarea" className="validate materialize-textarea" data-length="250" ></textarea>
                                    <label for="mensaje">Mensaje</label>
                                 </div>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col s12 m12 center-align">
                                 <button className="btn waves-light light-blue accent-3" type="submit">Enviar
                                    <i className="material-icons right">send</i>
                                 </button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
               <ToastContainer autoClose={1200}/>
            </div>
         </div> */}
         <div className="section white py-5 animated fadeIn">
            <div className="container">
               {/* ENCABEZADO DE LA SECCIÓN */}
               <div className="row center mb-4">
                  <div className="col s12">
                     <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                        Consultas y reclamos
                     </h4>
                     <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem' }}>
                        Completá el siguiente formulario de consultas/reclamos y un representante nuestro se comunicará a la brevedad.
                     </p>
                  </div>
               </div>
               {/* FORMULARIO ENMARCADO EN TARJETA CORPORATIVA */}
               <div className="row justify-content-center">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '40px' }}>
                        <form onSubmit={(e) => handleSubmit(e)}>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="text" name="nombre" id="nombre" ref={iNombreRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       nombre: e.target.value
                                    })}
                                    className="validate" data-length="15" />
                                 <label htmlFor="nombre">Nombre</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="text" name="apellido" id="apellido" ref={iApellidoRef} 
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       apellido: e.target.value
                                    })}
                                    className="validate" data-length="15" />
                                 <label htmlFor="apellido">Apellido</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="number" name="dni" id="dni" ref={iDniRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       dni: e.target.value
                                    })}
                                    className="validate" data-length="10" />
                                 <label htmlFor="dni">D.N.I</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="number" name="cuit_cuil" id="cuit_cuil" ref={iCuitCuilRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       cuit_cuil: e.target.value
                                    })}
                                    className="validate" data-length="13" />
                                 <label htmlFor="cuit_cuil">CUIT/CUIL</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="email" name="email" id="email" ref={iEmailRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       email: e.target.value
                                    })}
                                    className="validate" data-length="35" />
                                 <label htmlFor="email">E-mail</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <input type="tel" name="telefono" id="telefono" ref={iTelefonoRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       telefono: e.target.value
                                    })}
                                    className="validate" data-length="20"/>
                                 <label htmlFor="telefono">Teléfono</label>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <input type="text" name="domicilio" id="domicilio" ref={iDomiciolioRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       domicilio: e.target.value
                                    })}
                                    className="validate" data-length="60" />
                                 <label htmlFor="domicilio">Domicilio</label>
                              </div>
                              <div className="input-field col s12 m6">
                                 <select name="tipo" id="tipo" ref={sTipoRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       tipo: e.target.value,
                                    })} className="browser-default"
                                    style={{ backgroundColor: '#ffffff', border: '1px solid #9e9e9e', borderRadius: '4px', padding: '8px', color: '#424242' }}
                                 >
                                    <option value="" disabled selected>Tipo</option>
                                    <option value="Trabajador">Trabajador</option>
                                    <option value="Empleador">Empleador</option>
                                 </select>
                              </div>
                           </div>
                           <div className="row">
                              <div className="input-field col s12 m6">
                                 <select name="tipo_consulta" id="tipo_consulta" ref={sTipoConsultaRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       tipo_consulta: e.target.value,
                                    })} className="browser-default"
                                    style={{ backgroundColor: '#ffffff', border: '1px solid #9e9e9e', borderRadius: '4px', padding: '8px', color: '#424242' }}
                                 >
                                    <option value="" disabled selected>Tipo de consulta</option>
                                    <option value="Consulta">Consulta</option>
                                    <option value="Reclamos">Reclamos</option>
                                 </select>
                              </div>
                              <div className="input-field col s12 m6">
                                 <select name="tema_consulta" id="tema_consulta" ref={sTemaConsultaRef}
                                    onChange={(e) => setConsultaReclamo({
                                       ...consultaReclamo, 
                                       tema_consulta: e.target.value,
                                    })} className="browser-default"
                                    style={{ backgroundColor: '#ffffff', border: '1px solid #9e9e9e', borderRadius: '4px', padding: '8px', color: '#424242' }}
                                 >
                                    <option value="" disabled selected>Tema de consulta</option>
                                    <option value="1">Comisión médica</option>
                                    <option value="2">Prestaciones en especie</option>
                                    <option value="3">Prestaciones en dinerarias</option>
                                    <option value="4">Prevención</option>
                                    <option value="5">Exámenes Médicos</option>
                                    <option value="6">Afiliaciones y Contratos</option>
                                    <option value="7">Otros</option>
                                 </select>
                              </div>
                           </div>
                           <div className="row">
                              <div className="col s12 m12">
                                 <div className="input-field">
                                    <textarea name="mensaje" cols="40" rows="10" id="mensaje" ref={tMensajeRef}
                                       onChange={(e) => setConsultaReclamo({
                                          ...consultaReclamo, 
                                          mensaje: e.target.value,
                                       })} className="validate materialize-textarea" data-length="250"></textarea>
                                    <label htmlFor="mensaje">Mensaje</label>
                                 </div>
                              </div>
                           </div>
                           <div className="row mt-4">
                              <div className="col s12 m12 center-align">
                                 <button className="btn waves-effect waves-light light-blue accent-3 z-depth-1" type="submit" style={{ paddingLeft: '30px', paddingRight: '30px', borderRadius: '4px', fontWeight: '500' }}>
                                    Enviar
                                    <i className="material-icons right">send</i>
                                 </button>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
               <ToastContainer autoClose={1200}/>
            </div>
         </div>
      </>
   )
}

export default ConsultasReclamos